import type { ColumnsRowsFitSettings } from './types/columns-rows-fit-settings'
import type { GuideGutter } from './types/guide-gutter'

const MIN_GUTTER_POINTS = 1

export function doesGridFitPage(
  count: number | null,
  gutterPoints: number | null,
  pageInnerSize: number
): boolean {
  if (!Number.isFinite(pageInnerSize) || pageInnerSize < 1) return false
  if (count == null || !Number.isInteger(count) || count < 1) return false
  if (gutterPoints == null || !Number.isFinite(gutterPoints) || gutterPoints < MIN_GUTTER_POINTS) {
    return false
  }

  const totalGutter = gutterPoints * Math.max(0, count - 1)
  const availableContentSize = pageInnerSize - totalGutter

  return availableContentSize / count >= 1
}

export function doColumnsRowsSettingsFitPage(
  settings: ColumnsRowsFitSettings,
  pageInnerWidth: number,
  pageInnerHeight: number
): boolean {
  return (
    doesGridFitPage(settings.columns, settings.colGutter, pageInnerWidth) &&
    doesGridFitPage(settings.rows, settings.rowGutter, pageInnerHeight)
  )
}

export function computeGuideGutters(
  count: number | null,
  gutterPoints: number | null,
  innerSize: number
): GuideGutter[] {
  if (count == null || !Number.isInteger(count) || count < 2) return []
  if (gutterPoints == null || !Number.isFinite(gutterPoints) || gutterPoints < 0) return []
  if (!Number.isFinite(innerSize) || innerSize <= 0) return []

  const totalGutter = gutterPoints * (count - 1)
  const contentSize = innerSize - totalGutter

  if (contentSize <= 0) return []

  const cellSize = contentSize / count

  if (!Number.isFinite(cellSize) || cellSize <= 0) return []

  return Array.from({ length: count - 1 }, (_, offset) => {
    const index = offset + 1
    const start = index * cellSize + offset * gutterPoints

    return {
      index,
      start,
      end: start + gutterPoints,
    }
  })
}
